import URLS from 'apis/urls';

export const termTextList = [
  '1. 상기 정보는 최초 계약 시 작성한 정보이며, 광고 운영 중 발생한 변동사항에 따라 현재 노출 중인 정보와 다를 수 있습니다.\n2. 본인(업주)은 꼬르륵에게 위임하여 설정된 메뉴 이미지와 조리음식에 현저한 차이가 있다고 판단되는 경우, 이를 즉시 꼬르륵에게 고지하여야 합니다. 만약 메뉴 이미지와 실제 조리음식간에 현저한 차이가 발생하여 허위광고 또는 과장광고 등을 이유로 이용자(주문자)로 부터 문제제기가 발생하는 경우, 이에 대한 책임은 본인(업주)이 부담합니다\n3. 통신판매를 통해 제공하는 조리음식의 원산지 표시의 경우 거짓, 허위 표시하지 않음에 확약하며, 이를 위반시 본인(업주)가 법적인 책임을 부담합니다.',
  '본인(업주)은 별첨된 꼬르륵 서비스 이용약관을 모두 확인 및 숙지하였으며, 그 내용에 전적으로 동의함을 확인합니다.',
  '본인(업주)은 사업자변경 시 별첨된 꼬르륵 서비스 이용약관 내 리뷰승계허용범위에 대한 기준 약관의 내용을 모두 확인 및 숙지하였으며, 그 내용에 전적으로 동의함을 확인합니다.',
  '1. 본인(업주)은 주문을 통해 취득한 이용자(고객)의 주소, 연락처 등 이용자의 정보를 음식을 배달하기 위한 목적 외, 다른 어떠한 용도로 사용할 수 없습니다.\n2. 본인(업주)은 1항 외의 고객 개인정보 보호 관련하여 별첨된 꼬르륵 서비스 이용약관 내 개인정보 보호의 내용을 모두 확인 및 숙지하였으며, 그 내용에 전적으로 동의함을 확인합니다.',
  '1. 본인(업주)은 꼬르륵 서비스의 이용 및 광고, 외부결제 서비스 이용, 정산대금지급을 위하여 꼬르륵 서비스의 종료시까지 아래 항목들을 회사가 수집 및 보관하는 것에 동의함을 확인합니다.\n2. 수집항목\n   ㄱ.   신청인(대표자) 이름, 생년월일, 휴대폰 번호, 은행명, 계좌번호\n   ㄴ.   실운영자 이름, 이메일, 휴대폰 번호',
  '본인(업주)은 회사가 매장의 광고 및 관리 등의 이유로 매장의 지역내 영업업체(영업매니저) 또는 제3자(마케팅업체 등)에게 매장의 정보(매장명, 주소, 연락처 등)를 제공하는 것에 동의함을 확인합니다.',
  '1. 본인(업주)은 회사가 제공하는 서비스 이용과 관련하여 발생하는 수수료 지급 및 꼬르륵 캐시 충전 등을 위하여 금융기관 계좌에서 자동이체(출금)되는 것에 동의합니다.또한, 본인은 「전자금융거래법」 등 관련 법령에 따라 ㈜꼬르륵이 자동이체 출금 동의를 금융회사 등에 제공하는 것에 동의합니다.\n2. 본인(업주)은 꼬르륵 서비스 이용과 관련하여 발생하는 수수료 지급 및 꼬르륵 캐시 충전 등을 위하여 회사가 본인의 아래 항목들에 대한 정보를 수집 및 제3자(회사가 지정한 결제대행사)에게 제공하는 것을 동의합니다.\n  ㄱ.   은행명, 예금주, 계좌번호, 생년월일(사업자번호), 카드소유자이름, 카드번호, 유효기간, 비밀번호 앞 2자리',
  '꼬르륵 사장님 전용 프로모션, 이벤트, 광고 및 맞춤형 정보 제공을 위한 마케팅 활용에 동의합니다. (동의하지 않아도 서비스 이용에는 제한이 없습니다.)',
];

export const termsLabelList = [
  '계약 동의(필수)',
  '서비스 이용약관 동의(필수)',
  '리뷰승계 불가 동의(필수)',
  '고객 개인정보 보호(필수)',
  '업주 개인정보 수집 및 이용 동의(필수)',
  '개인정보 취급 및 위탁동의(필수)',
  '출금 동의(필수)',
  '마케팅 활용 동의 약관(선택)',
];

export const termsLinkList = [
  URLS.storeEfinanceTerms,
  URLS.storeTermsOfUse,
  URLS.reviewTermsOfUse,
  URLS.userPrivacyPolicy,
  URLS.privacyPolicy,
  URLS.storePrivacyPolicy,
  URLS.storeCashTerms,
  URLS.storeMarketingConsent,
];
